import {useEffect} from 'react';
import {auth} from './firebase';
import {accountRequest} from './account-api';
import {ANALYTICS_CHOICE_KEY,analyticsAllowed} from './analytics-choice';

// Optional daily counts: no trade content, page paths, input or tilt readings.
// Keep all interaction listeners off when the member has not opted in.
export default function useMemberActivity(uid,enabled){
  useEffect(()=>{
    if(!uid||!enabled)return;
    const abort=new AbortController();let lastSent=0,lastDay='',busy=false,stopped=false,observing=false,formatter;
    const report=async event=>{
      if(stopped||busy||!analyticsAllowed()||auth.currentUser?.uid!==uid||document.visibilityState!=='visible'||(!document.hasFocus()&&!event?.isTrusted))return;
      formatter ||= new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/London'});
      const today=formatter.format(new Date());
      if(Date.now()-lastSent<3600000&&today===lastDay)return;
      busy=true;lastSent=Date.now();lastDay=today;
      try{await accountRequest('/api/member-activity',{method:'POST',body:{consent:true},signal:abort.signal});}
      catch{lastSent=Date.now()-3540000;}
      finally{busy=false;}
    };
    const events=['pointerdown','keydown','touchstart','scroll'];
    const observe=value=>{
      if(value===observing)return;observing=value;
      events.forEach(type=>value?window.addEventListener(type,report,{passive:true}):window.removeEventListener(type,report));
      if(value)window.addEventListener('focus',report);else window.removeEventListener('focus',report);
    };
    const choice=event=>{
      if(event.type==='storage'&&event.key!==null&&event.key!==ANALYTICS_CHOICE_KEY)return;
      const allowed=analyticsAllowed();observe(allowed);
      if(allowed){lastSent=0;report();}
      else if(auth.currentUser?.uid===uid){accountRequest('/api/member-activity',{method:'DELETE',signal:abort.signal}).catch(()=>{});}
    };
    window.addEventListener('tradelog-analytics-choice',choice);window.addEventListener('storage',choice);
    observe(analyticsAllowed());if(observing)report();
    return()=>{stopped=true;abort.abort();observe(false);window.removeEventListener('tradelog-analytics-choice',choice);window.removeEventListener('storage',choice);};
  },[uid,enabled]);
}
